export const TITULO_PAGINA = 'Solicitação de cancelamento'

export const TITULO_PAGINA_SUSPENSAO = 'Antes de ir, que tal dar uma pausa?'

export const TITULO_PAGINA_SUSPENSAO_CONCLUSAO = 'Suspensão concluída'

export const TITULO_PAGINA_AVISO_MULTA = 'Você ainda não recebeu todas as caixinhas do seu plano anual!'

export const getDescricao = nome => {
  return `${nome}, é uma pena saber que você precisa sair do clube! Para concluir a sua solicitação de cancelamento é necessário preencher o formulário a seguir.`
}

export const TITULO_MODAL = 'Que notícia maravilhosa! 😊'

export const DESCRICAO_MODAL = 'Adoramos saber que você vai seguir com a gente, vivendo novas experiências literárias a cada caixinha. Prepare-se para muitas descobertas e ótimas leituras!'

export const ACAO_BOTAO_MODAL = 'Voltar para a home'

export const TEXTO_DUVIDAS = 'Se tiver dúvidas ou sugestões, escreva para a gente: 📩 '

export const EMAIL_CONTATO_TAG = 'contato@taglivros.com.br'

export const BOTAO_CONTINUAR = 'Continuar'

export const BOTAO_CONCLUIR_CANCELAMENTO = 'Concluir cancelamento'

export const BOTAO_CONCLUIR_SUSPENSAO = 'Concluir suspensão'

export const BOTAO_VOLTAR = 'Voltar'

export const BOTAO_IR_PARA_HOME = 'Ir para home'

export const SOLICITACAO_DESFEITA_TITULO = 'Assinatura reativada!'

export const SOLICITACAO_DESFEITA_DESCRICAO = 'Solicitação de cancelamento desfeita. Sua assinatura está ativa novamente.'

export const SOLICITACAO_DESFEITA_BOTAO = 'Ok, entendi.'

export const BOTAO_MODAL_DESFAZER_SOLICITACAO = 'Sim, desfazer'

export const BOTAO_MODAL_CANCELAR = 'Fechar aviso'

export const MODAL_CONFIRMACAO_DESCRICAO = 'Ao retirar a solicitação de cancelamento, você continuará assinando a TAG normalmente.'

export const MODAL_CONFIRMACAO_TITULO = 'Deseja desfazer sua solicitação de cancelamento da assinatura?'

export const BOTAO_SUSPENDER = 'Suspender por 1 mês'

export const BOTAO_SEGUIR_CANCELAMENTO = 'Seguir com o cancelamento'

export const BOTAO_AGUARDE = 'Aguarde...'
